module.exports = "/assets/ac464f0aead61483e452e18e2032ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/W9.png
// module id = 1952
// module chunks = 0